<div class="main-wrapper-section">
    <div class="common-header">
        <h3>Dashboard</h3>
    </div>
    <div class="common-header">
        <div class="date-row">
            <div class="date-row-column">
                <select class="form-control" [(ngModel)]="selectedCtDtFilter" (change)="filterDashboard($event.target.value)" style="width:auto; background:none; border:none; padding-left:0px; color:#212529; font-weight:500;">
                    <option value="1">This Month</option>
                    <option value="2">Last Month</option>
                    <option value="3">Custom</option>
                </select>
            </div>
            <div class="date-row-column">
                <div class="custom-date" *ngIf="customFilter">
                    <div class="display-flex">
                        <span class="date-range">Custom Range</span>
                        <mat-form-field appearance="outline">
                            <mat-date-range-input [rangePicker]="dateRangePicker" [formGroup]="currentRange">
                                <input matStartDate placeholder="Start date" formControlName="start" #dateRangeStart>
                                <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle class="custom-daterange-toggle" matPrefix [for]="dateRangePicker"></mat-datepicker-toggle>
                            <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
                            <span *ngIf="currentRange.controls.start.hasError('matStartDateInvalid')"><mat-error>Invalid start date</mat-error></span>
                            <span *ngIf="currentRange.controls.end.hasError('matEndDateInvalid')"><mat-error>Invalid end date</mat-error></span>
                        </mat-form-field>
                        <i class="fa fa-undo" *ngIf="customFilter" (click)="revertCustomFinalizeddtFilter()" style="font-size:20px; margin-left:10px;"></i>
                    </div>
                </div>
                <!--</div>-->
            </div>
        </div>
    </div>

    <div class="alignment-content">
        <div class="flex-row">
            <div class="flex-column1">
                <div class="inner-flex-row">
                    <div class="common-card">
                        <div class="card-panel">
                            <h6>Contracts</h6>
                            <div class="hightlight-text">
                                <h1>{{cmDashBoardResponse?.totalContracts}}</h1>
                            </div>
                        </div>
                    </div>
                    <div class="common-card">
                        <div class="card-panel">
                            <h6>Fees Collected</h6>
                            <div class="hightlight-text">
                                <h1>{{cmDashBoardResponse?.totalFees | currency}}</h1>
                            </div>
                        </div>
                    </div>
                    <div class="common-card">
                        <div class="card-panel">
                            <h6>By Agent</h6>
                            <div class="table-panel">
                                <div class="table-body">
                                    <table mat-table [dataSource]="dataSourceAgent" class="">
                                        <ng-container matColumnDef="userName">
                                            <th mat-header-cell *matHeaderCellDef>Agent</th>
                                            <td mat-cell *matCellDef="let element">{{element.userName}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="totalContracts">
                                            <th mat-header-cell *matHeaderCellDef>Contracts</th>
                                            <td mat-cell *matCellDef="let element">{{element.totalContracts}}</td>
                                        </ng-container>

                                        <!-- Assign columns to the table -->
                                        <tr mat-header-row *matHeaderRowDef="displayedColumnsAgent"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumnsAgent;"></tr>
                                    </table>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="common-card">
                        <div class="card-panel">
                            <h6>By Contract Status</h6>
                            <div class="table-panel">
                                <div class="table-body">
                                    <table mat-table [dataSource]="dataSourceStatus" class="">
                                        <ng-container matColumnDef="status">
                                            <th mat-header-cell *matHeaderCellDef>Status</th>
                                            <td mat-cell *matCellDef="let element">{{element.status}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="count">
                                            <th mat-header-cell *matHeaderCellDef>Contracts</th>
                                            <td mat-cell *matCellDef="let element">{{element.count}}</td>
                                        </ng-container>

                                        <!-- Assign columns to the table -->
                                        <tr mat-header-row *matHeaderRowDef="displayedColumnsStatus"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumnsStatus;"></tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="common-card">
                        <div class="card-panel">
                            <h6>By Site</h6>
                            <div class="table-panel">
                                <div class="table-body">
                                    <table mat-table [dataSource]="dataSourceSite" class="">
                                        <ng-container matColumnDef="siteName">
                                            <th mat-header-cell *matHeaderCellDef>Site</th>
                                            <td mat-cell *matCellDef="let element">{{element.siteName}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="contractCounts">
                                            <th mat-header-cell *matHeaderCellDef>Contracts</th>
                                            <td mat-cell *matCellDef="let element">{{element.contractCounts}}</td>
                                        </ng-container>

                                        <!-- Assign columns to the table -->
                                        <tr mat-header-row *matHeaderRowDef="displayedColumnsSite"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumnsSite;"></tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="common-card">
                        <div class="card-panel">
                            <h6>Collected Fees</h6>
                            <div class="table-panel">
                                <div class="table-body">
                                    <table mat-table [dataSource]="dataSourceClubFee" class="">
                                        <ng-container matColumnDef="totalContractFeePaid">
                                            <th mat-header-cell *matHeaderCellDef>Total</th>
                                            <td mat-cell *matCellDef="let element">{{element.totalContractFeePaid | currency}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="cMContractCounts">
                                            <th mat-header-cell *matHeaderCellDef>Contracts</th>
                                            <td mat-cell *matCellDef="let element">{{element.cMContractCounts}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="avg">
                                            <th mat-header-cell *matHeaderCellDef>Avg.</th>
                                            <td mat-cell *matCellDef="let element">{{element.avg | currency}}</td>
                                        </ng-container>

                                        <!-- Assign columns to the table -->
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
